module.exports = __webpack_public_path__ + "img/IMG_053422.7355c89f.png";